import SectionMessage from '@atlaskit/section-message';

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import config from 'appconfig';
import { Font, Dimensions } from 'components/visuals';
import t from 'modules/i18n/intl';
import type { State } from 'model/State';

import { selectShouldDisplayDataCenterApprovedAppsMessage } from './duck/server/selectors';

const Wrapper = styled.div`
  margin-bottom: ${Dimensions.units(3)}px;
  font-family: ${Font.family};
`;

type StateProps = {
  show: boolean;
};

const DCAppsFAQLink = (chunks) => (
  <a href={`${config.wacUrl}/licensing/data-center-approved-apps`} target="_blank" rel="noreferrer">
    {chunks}
  </a>
);

const DataCenterApprovedAppsMessage = (props: StateProps) =>
  props.show && (
    <Wrapper>
      <SectionMessage appearance="information">
        {t(
          {
            id: 'review.data-center-approved-message',
            defaultMessage:
              'Please keep in mind after 3rd September 2019 DC Instances require you to run a DC Approved version of an app if one exists. Please review any licenses you have running on your DC instance to ensure you are renewing the correct license. For more information on the DC program, please see our <link>DC Apps FAQ</link>.',
          },
          {
            link: DCAppsFAQLink,
          },
        )}
      </SectionMessage>
    </Wrapper>
  );

const mapStateToProps = (state: State): StateProps => ({
  show: selectShouldDisplayDataCenterApprovedAppsMessage(state),
});

export default connect(mapStateToProps)(DataCenterApprovedAppsMessage);
